import { OmniaConfig } from "./shared/config"
import { IOmnniaSessionState } from "./shared/types"
import { escape } from "./shared/utils/regexp"

export function setupBlockUi(blockUIConfig: any, config: OmniaConfig, state: IOmnniaSessionState) {

    const exclusions = [
        "dev.virtualearth.net",
        "tile.openstreetmap.org",
        "api/import/tasks/get",
        "api/imports/sync/state",
        "api/reports/holding"
    ].map(e => new RegExp(escape(e), "i"))

    blockUIConfig.message = "Please wait..."
    blockUIConfig.autoBlock = true

    blockUIConfig.template = `
<div class='block-ui-overlay'></div>
<div class='block-ui-message'>
    <h2>${config.brand.name} is loading</h2>
    <div class='b'>
        <svg class=\"spinner\" width=\"65px\" height=\"65px\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg>
        <div class='message'>{{ state.message }}</div>
    </div>
</div>`

    blockUIConfig.requestFilter = (config: any) => {

        const opts: { block?: boolean, message?: string } = config["_omnia"] || {}

        if (opts.block === false) {
            return false
        }

        if (opts.block !== true) {

            if (exclusions.some(e => e.test(config.url))) {
                return false
            }

            if (state.state == "loginInProgress") {
                return true
            }

            if (state.state != "loggedIn") {
                return false
            }

            if (state.disableBlockUI) {
                return false
            }

        }

        return opts.message || true

    }

}
